/* eslint-disable */
export default {
  DirectNumber: '直拨',
  MainCompanyNumber: '主号码',
  CompanyNumber: '公司',
  CompanyFaxNumber: '传真',
  Blocked: '阻止显示主叫信息',
  AdditionalCompanyNumber: '公司',
  ForwardedCompanyNumber: '已转接',
  from: '自',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
